import { useMemo } from 'react';
import { Eye } from 'lucide-react';
import { sampleFlows } from '@/data/sampleFlows';
import { getScreensFromFlow } from '@/types/flow';
import ScreenRenderer from '@/components/preview/ScreenRenderer';
import adeliraLogo from '@/assets/adelira-logo.png';

const ABVisualComparison = () => {
  const flow = sampleFlows.find(f => f.id === '4')!;
  const rawScreens = getScreensFromFlow(flow);

  const variantScreens = useMemo(() => {
    const screen1 = rawScreens[0];
    if (!screen1) return { A: null, B: null };

    const a2Index = screen1.steps.findIndex(s => s.id === 'a2');
    const screenB = a2Index !== -1 ? {
      ...screen1,
      steps: [
        ...screen1.steps.slice(0, a2Index + 1),
        { id: 'a2_social_proof', type: 'text' as const, title: '✅ 5.800+ vrouwen gingen je voor', screenId: screen1.steps[0]?.screenId, settings: { align: 'center' as const }, design: { fontSize: 14, fontSizeMobile: 13, fontWeight: '600', color: '#16a34a', margin: '4px 0 0 0' } },
        ...screen1.steps.slice(a2Index + 1),
      ],
    } : screen1;

    return { A: screen1, B: screenB };
  }, [rawScreens]);

  if (!variantScreens.A || !variantScreens.B) return null;

  const noop = () => {};

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5">
      <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Eye className="w-4 h-4" />
        Visuele vergelijking scherm 1
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Variant A */}
        <div className="border border-blue-200 rounded-xl overflow-hidden">
          <div className="bg-blue-50 px-4 py-2 flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-md text-xs font-bold bg-blue-100 text-blue-700">A</span>
            <span className="text-sm font-medium text-blue-800">Zonder social proof (huidige versie)</span>
          </div>
          <div className="bg-white">
            <div className="bg-[#0F1C2E] h-16 flex items-center justify-center">
              <img src={adeliraLogo} alt="Adelira" className="h-12 object-contain" />
            </div>
            <div className="h-1 bg-gray-100">
              <div className="h-full bg-gray-300 w-[5%]" />
            </div>
            <div className="px-4 py-6 pointer-events-none">
              <ScreenRenderer
                steps={variantScreens.A.steps}
                onAdvance={noop}
                accentColor={flow.accentColor}
              />
            </div>
          </div>
        </div>

        {/* Variant B */}
        <div className="border border-purple-200 rounded-xl overflow-hidden">
          <div className="bg-purple-50 px-4 py-2 flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-md text-xs font-bold bg-purple-100 text-purple-700">B</span>
            <span className="text-sm font-medium text-purple-800">Met social proof op scherm 1</span>
          </div>
          <div className="bg-white">
            <div className="bg-[#0F1C2E] h-16 flex items-center justify-center">
              <img src={adeliraLogo} alt="Adelira" className="h-12 object-contain" />
            </div>
            <div className="h-1 bg-gray-100">
              <div className="h-full bg-gray-300 w-[5%]" />
            </div>
            <div className="px-4 py-6 pointer-events-none">
              <ScreenRenderer
                steps={variantScreens.B.steps}
                onAdvance={noop}
                accentColor={flow.accentColor}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ABVisualComparison;
